import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#historie", label: "Velkommen" },
  { href: "#program", label: "Program" },
  { href: "#sted", label: "Sted" },
  { href: "#galleri", label: "Galleri" },
  { href: "#gaveliste", label: "Gaveliste" },
  { href: "#rsvp", label: "RSVP" },
  { href: "#overnatting", label: "Overnatting" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F3F5E7]/85 backdrop-blur-xl border-b border-[#68919B33]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="navbar-logo"
          className={`font-serif text-xl tracking-wide transition-colors ${
            scrolled ? "text-[#3D5E68]" : "text-white"
          }`}
        >
          C <span className="text-[#68919B] mx-1">&</span> A
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className={`text-xs uppercase tracking-[0.25em] font-light transition-colors hover:text-[#68919B] ${
                  scrolled ? "text-[#3D5E68]" : "text-white/90"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          aria-label="Meny"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className={`lg:hidden p-2 transition-colors ${
            scrolled ? "text-[#3D5E68]" : "text-white"
          }`}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden bg-[#F3F5E7]/95 backdrop-blur-xl border-t border-[#68919B33]"
          data-testid="mobile-menu-panel"
        >
          <ul className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-sm uppercase tracking-[0.2em] font-light text-[#3D5E68] hover:text-[#68919B]"
                  data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};
